import './auth.css';
import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { login, signup } from './authActions';
import Messages from '../common/msg/messages';
import Input from '../common/form/inputAuth';
import logo from '../image/logo_login_metallic.png';

class Auth extends Component {
  constructor(props) {
    super(props);
    this.state = { loginMode: true };
  }

  changeMode() {
    this.setState({ loginMode: !this.state.loginMode });
  }

  onSubmit(values) {
    const { login, signup } = this.props;
    this.state.loginMode ? login(values) : signup(values);
  }

  render() {
    const { loginMode } = this.state;
    const { handleSubmit } = this.props;

    return (
      <div className="login-box">
        <div className="login-branding">
          <div className="login-branding-logo-wrap">
            <img src={logo} alt="SSAT Sinalização Viária" className="login-branding-logo" />
          </div>
          <div className="login-contacts">
            <a href="tel:+554735213245" className="login-contact-item">
              <i className="fa fa-phone" aria-hidden="true" />
              <span>47 3521-3245</span>
            </a>
            <a
              href="https://wa.me/5547988727743"
              target="_blank"
              rel="noopener noreferrer"
              className="login-contact-item login-contact-item--whatsapp"
            >
              <i className="ion ion-logo-whatsapp" aria-hidden="true" />
              <span>47 98872-7743</span>
            </a>
          </div>
        </div>

        <div className="login-wrapper">
          <div className="login-card login-form">
            <p className="login-welcome">{loginMode ? 'Bem vindo!' : 'Criar conta'}</p>
            <p className="login-tagline">Inteligência que move a cidade</p>

            <form onSubmit={handleSubmit(v => this.onSubmit(v))}>
              <Field
                component={Input}
                type="input"
                name="name"
                placeholder="Nome"
                icon="user"
                hide={loginMode}
              />
              <Field
                component={Input}
                type="email"
                name="email"
                placeholder="E-mail"
                icon="envelope"
              />
              <Field
                component={Input}
                type="password"
                name="password"
                placeholder="Senha"
                icon="lock"
              />
              <Field
                component={Input}
                type="password"
                name="confirm_password"
                placeholder="Confirmar Senha"
                icon="lock"
                hide={loginMode}
              />

              <button type="submit" className="login-submit">
                {loginMode ? 'Entrar' : 'Registrar'}
              </button>
            </form>
          </div>

          <Messages />
        </div>
      </div>
    );
  }
}

Auth = reduxForm({ form: 'authForm' })(Auth);
const mapDispatchToProps = dispatch => bindActionCreators({ login, signup }, dispatch);
export default connect(null, mapDispatchToProps)(Auth);
